<ng-container *ngIf="!environment.production">
   <button id="theme-switch" mat-icon-button matTooltip="Switch Theme" [matMenuTriggerFor]="themeMenu" class="common-m005em">
      <mat-icon>palette</mat-icon>
   </button>

   <mat-menu #themeMenu="matMenu">
      <button [id]="'theme-switch-' + theme.name" mat-menu-item *ngFor="let theme of branding.getAllThemes() | async" (click)="loadTheme( theme.brand )">
         {{theme.name}}
      </button>
   </mat-menu>
</ng-container>
